import { useState,useEffect } from "react";
import UserContext from "./UserContext";
import { APIs, API_BASE_URL, AuthRoutes, roleAccess, commonAllowedRolesAccess, USERTYPES, NonAuthRoutes, SERVICEURL, SHARED_SERVICEURL } from "../../constants/Constants";
import axios from "axios";
import Moment from "moment";
import { encryptData } from "../../helpers/RSAUtility";
import axiosInterceptor from "../../helpers/Interceptor";
import { v4 as uuidv4 } from 'uuid';
import { jwtDecode } from "jwt-decode";
import { getEnv } from '../../helpers/EnvHelper';
import { refreshToken as refreshJwtCookie } from "../../service/RefreshTokenService";

axios.defaults.withCredentials = true;

const UserState = (props) => {

  const queryString = window.location.search;
  // Create a URLSearchParams object
  const urlParams = new URLSearchParams(queryString);

 

  const [contextSwitchUser , setContextSwitchUser] = useState(false);
  const [unautherizedAccessObj, setShowUnauthunautherizedAccessObj] = useState({
    showError:false,
    errorMsg: ""
  });

  const [contextSwitchStudyviewer , setContextSwitchStudyviewer] = useState(false);

  const [userDetail, setUserDetail] = useState({});
  const [token, setToken] = useState("");
  const [authenticated, setAuthenticated] = useState(false);
  const [userId, setUserId] = useState("");
  const [username, setUsername] = useState("");
  const [roles, setRoles] = useState([]);
  const [email, setEmail] = useState("");
  const [showSuccessToast, setSuccessToast] = useState(false);
  const [qcReviewer, setQcReviewer] = useState();
  const [qcOutsourceLogin, setQcOutsourceLogin] = useState();
  const [name, setName] = useState("");
  const [firmId, setFirmId] = useState();
  const [firmName, setFirmName] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [lastResetPasswordDate, setLastResetPasswordDate] = useState(null);
  const [showPasswordExpiryMessage, setShowPasswordExpiryMessage] = useState(false);
  const [daysRemainingForExpiry, setDaysRemainingForExpiry] = useState(0);
  const [editorName, setEditorName] = useState("froala");
  const [userSettings, setUserSettings] = useState(null);
  const [isActiveData, setIsActiveData] = useState(true);
  const [radiologistType, setRadiologistType] = useState(null);
  const [enableLlmReport , setEnableLlmReport] = useState(() => localStorage.getItem("enableLlmReport") === "true");
  const [twoFAGlobalEnable , setTwoFAGlobalEnable] = useState(false);
  const [twoMonitorEnabled, setTwoMonitorEnabled] = useState(false);
  const [customerSupportNumber,setcustomerSupportNumber]=useState("");
  const [privilegedFirmDoctor , setPrivilegedFirmDoctor] = useState(false);
  const [peerReviewAdmin, setPeerReviewAdmin] = useState(false);
  const [peerReviewEvaluator, setPeedReviewEvaluator] = useState(false);
  const [resetPasswordAllowed,setResetPasswordAllowed]=useState(false);
  const [forcedLogoutAllowed,setForcedLogoutAllowed]=useState(false);
  const [enableStudyUpload, setEnableStudyUpload] = useState(false);
  const [showSavedReport, setShowSavedReport] = useState(false);
  const [showAiResults, setShowAiResults] = useState(false);
  const [ exportCsvAllowed, setExportCsvAllowed ] = useState(false);
  const [ disableSubmitforResident, setDisableSubmitforResident ] = useState(false);
  const [ typistAllowSubmit, setTypistAllowSubmit ] = useState(true);
  const [ multipleActiveSessions, setMultipleActiveSessions ] = useState(false);
  const [ blitzSessionEnabled, setBlitzSessionEnabled ] = useState(false);
  const [ routeToNodeEnabled, setRouteToNodeEnabled ] = useState(false);
  const [ aiRouteToNodeEnabled, setAiRouteToNodeEnabled ] = useState(false);
  const [ qcSelfLockDisabled, setQcSelfLockDisabled ] = useState(false);
  const [ qcOpenStudyDisabled, setQcOpenStudyDisabled ] = useState(false);
  const [ userTimeZone, setUserTimeZone ] = useState(null);
  const [enableReportAndHeaderTemplateConfigurations, setEnableReportAndHeaderTemplateConfigurations] = useState(false);
  const [ priviledgedFirmTechnician, setPriviledgedFirmTechnician ] = useState(false);
  const [ showViewerTechnician, setShowViewerTechnician ] = useState(false);
  const [defaultCountry, setDefaultCountry] = useState("in");

  const MACHINE_ID_KEY = "md";
  const getMachineId = () => {
    let machineId = localStorage.getItem(MACHINE_ID_KEY);
    if (!machineId) {
        machineId = uuidv4();
        localStorage.setItem(MACHINE_ID_KEY, machineId);
    }
    return machineId;
  };

  const signin = async (username, password) => {
    try {
      
      const machineId = getMachineId();
      const response = await axios.post(
        API_BASE_URL + "auth/signin",
        {
          // const response = await axios.post("https://enl81exnk1zih.x.pipedream.net/",{
          username: username,
          password: password,
        },
        {
          // withCredentials: true,
          headers: { "Content-Type": "application/json", 
            "X-machineId":machineId
          },
          // credentials: 'include'
        }
      );

      console.log("--- User State Response -----", response);
      // --- NEW: persist 2FA / OTP channel info returned by server (if any)
      try {
        const respData = (response && response.data && response.data.data) ? response.data.data : null;
        // The backend sends otpGenerateDto in data for Pending (2FA) case:
        // { email, emailSent, whatsappSent, whatsappNumber }
        if (respData) {
          // for password reset / 2FA flows we want to persist returned masked contacts
          if (respData.email) {
            // For generic flows backend returns "email" (masked); store as forgotPassword or 2fa as needed
            // We'll store both keys so components can read the appropriate one
            localStorage.setItem("forgotPasswordEmail", respData.email);
            localStorage.setItem("2faEmail", respData.email);
          }
          if (respData.whatsappNumber) {
            localStorage.setItem("forgotPasswordWhatsApp", respData.whatsappNumber);
            localStorage.setItem("2faWhatsApp", respData.whatsappNumber);
          }
          if (typeof respData.emailSent !== "undefined") {
            localStorage.setItem("2faEmailSent", respData.emailSent.toString());
            localStorage.setItem("forgotPasswordEmailSent", respData.emailSent.toString());
          }
          if (typeof respData.whatsappSent !== "undefined") {
            localStorage.setItem("2faWhatsappSent", respData.whatsappSent.toString());
            localStorage.setItem("forgotPasswordWhatsappSent", respData.whatsappSent.toString());
          }
        }
      } catch (e) {
        // swallow errors — non-critical
        console.debug("Could not persist OTP channel info from signin:", e);
      }

      if(response.data.result !== "Pending"){
        setToken(response.data.data.accessToken);

        // ✅ Decode the JWT to extract roles and username
        const decoded = jwtDecode(response.data.data.token);

        // Assuming backend added "username" and "roles" claims
        const roles = decoded.roles || [];
        const usernameFromToken = decoded.username || "";

        // ✅ Set roles and username from token
        setRoles(roles);
        setUsername(usernameFromToken);

        setUserId(response.data.data.id);
        // setUsername(response.data.data.username);
        setEmail(response.data.data.email);
        // setRoles(response.data.data.roles);
        setcustomerSupportNumber(response.data.data.customerSupportNumber);
        setPrivilegedFirmDoctor(response.data.data.privilegedFirmDoctor);
        setPriviledgedFirmTechnician(response.data.data.privilegedFirmTechnician);
        setShowViewerTechnician(response.data.data.showViewerTechnician);
        setPeerReviewAdmin(response.data.data.peerReviewAdmin);
        setPeedReviewEvaluator(response.data.data.peerReviewEvaluator);
        setResetPasswordAllowed(response.data.data.passwordResetAllowed);
        setForcedLogoutAllowed(response.data.data.forcedLogoutAllowed);
        setExportCsvAllowed(response.data.data.exportCsvAllowed);
        setEnableStudyUpload(response.data.data.enableStudyUpload);
        setShowAiResults(response.data.data.showAiResults);
        setShowSavedReport(response.data.data.showSavedReport);
        setDisableSubmitforResident(response.data.data?.disableSubmit);
        setTypistAllowSubmit(response.data.data?.allowSubmit ?? true);
        setFirmId(response.data.data.firmId);
        setIsActiveData(getEnv("REACT_APP_PARTITION_MODE") == "false" ? true : response.data.data.activeData);
        setEnableLlmReport(response.data.data.enableLlmReport);
        localStorage.setItem("enableLlmReport", response.data.data.enableLlmReport ? "true" : "false");
        setEnableReportAndHeaderTemplateConfigurations(response.data.data.enableReportAndHeaderTemplateConfigurations);
        if(response.data.data?.firmName != undefined && response.data?.data?.firmName != null){
          setFirmName(response.data.data.firmName);
        }
        setQcReviewer(response.data.data.qcReviewer);
        setQcOutsourceLogin(response.data.data.qcOutsourceLogin);
        setName(
          response.data.data.name == undefined
            ? username
            : response.data.data.name
        );
        setShowConfirmation(response.data.data.showConfirmation);
        setLastResetPasswordDate(response.data.data.lastResetPasswordDate);
        setBlitzSessionEnabled(response.data.data?.blitzSessionEnabled);
        setQcSelfLockDisabled(response.data.data?.qcSelfLockDisabled);
        setQcOpenStudyDisabled(response.data.data?.qcOpenStudyDisabled);
        setRouteToNodeEnabled(response.data.data?.routeToNodeEnabled);
        setAiRouteToNodeEnabled(response.data.data?.aiRouteToNodeEnabled);
        if(response?.data?.data?.userSettings?.length > 6 && response?.data?.data?.userSettings != ""){
          const parsedSettings = JSON.parse(response.data.data.userSettings);
          setUserSettings(parsedSettings);
          if (parsedSettings?.theme) {
            localStorage.setItem("theme", parsedSettings.theme);
          }
        }
        if (
          response.data.data.editorName != undefined &&
          response.data.data.editorName != null
        ) {
          setEditorName(response.data.data.editorName);
        } else {
          setEditorName("ckeditor");
        }

        setAuthenticated(true);
        localStorage.setItem("hasSession", "1");
        setMultipleActiveSessions(response.data.data.multipleActiveSessions);
        setUserTimeZone(response.data.data.userTimeZone);
        localStorage.setItem("userTimeZone", response.data.data.userTimeZone);
        // localStorage.setItem("refreshToken", response.data.data.refreshToken);
        // localStorage.setItem("username", response.data.data.username);
        localStorage.setItem("forceReset", response.data.data.forceReset);
        localStorage.setItem(
          "redirectOnLogin",
          response.data.data.redirectOnLogin
        );
      }
      return response;
    } catch (error) {
      return error.response ?? { status: 0, data: { message: "NETWORK_ERROR" } };
    }
  };


  const signin2 = async (username, password) => {
    try {
      
      const machineId = getMachineId();
      console.log("Machine id- "+machineId);
      const response = await axios.post(
        "https://augmento-demo.deeptek.ai:8002/" + "auth/signin",
        {
          // const response = await axios.post("https://enl81exnk1zih.x.pipedream.net/",{
          username: username,
          password: password,
        },
        {
          // withCredentials: true,
          headers: { "Content-Type": "application/json", 
            "X-machineId":machineId
          },
          // credentials: 'include'
        }
      );

      console.log("--- User State Response -----", response);
      if(response.data.result !== "Pending"){
        setToken(response.data.data.accessToken);
        setUserId(response.data.data.id);
        setUsername(response.data.data.username);
        setEmail(response.data.data.email);
        setRoles(response.data.data.roles);
        setcustomerSupportNumber(response.data.data.customerSupportNumber);
        setPrivilegedFirmDoctor(response.data.data.privilegedFirmDoctor);
        setPriviledgedFirmTechnician(response.data.data.privilegedFirmTechnician);
        setShowViewerTechnician(response.data.data.showViewerTechnician);
        setPeerReviewAdmin(response.data.data.peerReviewAdmin);
        setPeedReviewEvaluator(response.data.data.peerReviewEvaluator);
        setResetPasswordAllowed(response.data.data.passwordResetAllowed);
        setForcedLogoutAllowed(response.data.data.forcedLogoutAllowed);
        setExportCsvAllowed(response.data.data.exportCsvAllowed);
        setEnableStudyUpload(response.data.data.enableStudyUpload);
        setShowAiResults(response.data.data.showAiResults);
        setShowSavedReport(response.data.data.showSavedReport);
        setFirmId(response.data.data.firmId);
        setIsActiveData(getEnv("REACT_APP_PARTITION_MODE") == "false" ? true : response.data.data.activeData);
        setEnableReportAndHeaderTemplateConfigurations(response.data.data.enableReportAndHeaderTemplateConfigurations);
        if(response.data.data?.firmName != undefined && response.data?.data?.firmName != null){
          setFirmName(response.data.data.firmName);
        }
        setQcReviewer(response.data.data.qcReviewer);
        setQcOutsourceLogin(response.data.data.qcOutsourceLogin);
        setName(
          response.data.data.name == undefined
            ? username
            : response.data.data.name
        );
        setShowConfirmation(response.data.data.showConfirmation);
        setLastResetPasswordDate(response.data.data.lastResetPasswordDate);
        setBlitzSessionEnabled(response.data.data?.blitzSessionEnabled);
        setQcSelfLockDisabled(response.data.data?.qcSelfLockDisabled);
        setQcOpenStudyDisabled(response.data.data?.qcOpenStudyDisabled);
        setRouteToNodeEnabled(response.data.data?.routeToNodeEnabled);
        setAiRouteToNodeEnabled(response.data.data?.aiRouteToNodeEnabled);
        if(response?.data?.data?.userSettings?.length > 6 && response?.data?.data?.userSettings != ""){
          const parsedSettings = JSON.parse(response.data.data.userSettings);
          setUserSettings(parsedSettings);
          if (parsedSettings?.theme) {
            localStorage.setItem("theme", parsedSettings.theme);
          }
        }
        if (
          response.data.data.editorName != undefined &&
          response.data.data.editorName != null
        ) {
          setEditorName(response.data.data.editorName);
        } else {
          setEditorName("ckeditor");
        }

        setAuthenticated(true);
        localStorage.setItem("hasSession", "1");
        setMultipleActiveSessions(response.data.data.multipleActiveSessions);
        // localStorage.setItem("refreshToken", response.data.data.refreshToken);
        // localStorage.setItem("username", response.data.data.username);
        localStorage.setItem("forceReset", response.data.data.forceReset);
        localStorage.setItem(
          "redirectOnLogin",
          response.data.data.redirectOnLogin
        );
      }
      return response;
    } catch (error) {
      return error.response;
    }
  };

  const loadByUsername = async () => {
    if (!localStorage.getItem("hasSession")) {
      return false;
    }
    try {
      let response = null;
      if(NonAuthRoutes.CONTEXTSWITCHSTUDYLIST === window.location.pathname){

         // Get a specific query parameter
        const clientId = urlParams.get('clientId');
        const secretKey = urlParams.get('secretKey');
        const patientId = urlParams.get('patientId');

        response =  await axiosInterceptor.post(
          API_BASE_URL + SHARED_SERVICEURL + "/open-api/authenticate" ,{
            data: {
              clientId: clientId,
              secretKey: secretKey,
              patientId: patientId
          
            },
            
          }
        );
        
        if(response.status == 200 && response.data.result=="FAILURE"){
          setShowUnauthunautherizedAccessObj (()=>{
            const newItem = {...unautherizedAccessObj};
            newItem.showError = true;
            newItem.errorMsg = response.data.message;
            return newItem;
            });
        }
        setContextSwitchUser(true);
        
      }else if(NonAuthRoutes.CONTEXTSWITCHSTUDYVIEWER === window.location.pathname){
            // Get a specific query parameter
            const clientId = urlParams.get('clientId');
            const secretKey = urlParams.get('secretKey');
            const studyId = urlParams.get('studyId');

            response =  await axiosInterceptor.post(
              API_BASE_URL + SHARED_SERVICEURL + "/open-api/authenticate" ,{
                data: {
                  clientId: clientId,
                  secretKey: secretKey,
                  studyId: studyId
              
                },
                
              }
            );
            if(response.status == 200 && response.data.result=="FAILURE"){
              setShowUnauthunautherizedAccessObj (()=>{
                const newItem = {...unautherizedAccessObj};
                newItem.showError = true;
                newItem.errorMsg = response.data.message;
                return newItem;
                });
            }
            setContextSwitchUser(true);
            setContextSwitchStudyviewer(true);
      }
      else{
        
         response = await axiosInterceptor.post(
          API_BASE_URL + APIs.LOADUSERDATA
        );
      }
      // console.log("User data response ", response);
      if (response.status === 200 && response.data.result === "Success") {
        // console.log("--- User State Response -----", response);
        
        // ✅ Decode the JWT to extract roles and username
        const decoded = jwtDecode(response.data.data.token);

        // Assuming backend added "username" and "roles" claims
        const roles = decoded.roles || [];
        const usernameFromToken = decoded.username || "";

        // ✅ Set roles and username from token
        setRoles(roles);
        setUsername(usernameFromToken);

        setUserId(response.data.data.id);
        // setUsername(response.data.data.username);
        setEmail(response.data.data.email);
        // setRoles(response.data.data.roles);
        setAuthenticated(true);
        localStorage.setItem("hasSession", "1");
        setContextSwitchUser(response.data.data.contextSwitchUser);
        setName(
          response.data.data.name == undefined
            ? username
            : response.data.data.name
        );
        if(response?.data?.data?.userSettings?.length > 6 && response?.data?.data?.userSettings != ""){
          const parsedSettings = JSON.parse(response.data.data.userSettings);
          setUserSettings(parsedSettings);
          if (parsedSettings?.theme) {
            localStorage.setItem("theme", parsedSettings.theme);
          }
        }
        setFirmId(response.data.data.firmId);
        setIsActiveData(getEnv("REACT_APP_PARTITION_MODE") == "false" ? true : response.data.data.activeData);
        if(response.data.data?.firmName != undefined && response.data?.data?.firmName != null){
          setFirmName(response.data.data.firmName);
        }
        setEditorName("froala");  
        setQcReviewer(response.data.data.qcReviewer);
        setQcOutsourceLogin(response.data.data.qcOutsourceLogin);
        setShowConfirmation(response.data.data.showConfirmation);
        setLastResetPasswordDate(response.data.data.lastResetPasswordDate);
        setRadiologistType(response.data.data.radiologistType);
        setEnableLlmReport(response.data.data?.enableLlmReport);
        localStorage.setItem("enableLlmReport", response.data.data?.enableLlmReport ? "true" : "false");
        setTwoFAGlobalEnable(response.data.data?.twoFAGlobalFlag);
        setcustomerSupportNumber(response.data.data.customerSupportNumber);
        setPrivilegedFirmDoctor(response.data.data?.privilegedFirmDoctor);
        setPriviledgedFirmTechnician(response.data.data?.privilegedFirmTechnician);
        setShowViewerTechnician(response.data.data?.showViewerTechnician);
        setPeerReviewAdmin(response.data.data?.peerReviewAdmin);
        setPeedReviewEvaluator(response.data.data?.peerReviewEvaluator);
        setResetPasswordAllowed(response.data.data?.passwordResetAllowed);
        setForcedLogoutAllowed(response.data.data?.forcedLogoutAllowed);
        setExportCsvAllowed(response.data.data?.exportCsvAllowed);
        setEnableStudyUpload(response.data.data?.enableStudyUpload); 
        setShowAiResults(response.data.data?.showAiResults);
        setShowSavedReport(response.data.data?.showSavedReport);
        setDisableSubmitforResident(response.data.data?.disableSubmit);
        setTypistAllowSubmit(response.data.data?.allowSubmit ?? true);
        setBlitzSessionEnabled(response.data.data?.blitzSessionEnabled);
        setQcSelfLockDisabled(response.data.data?.qcSelfLockDisabled);
        setQcOpenStudyDisabled(response.data.data?.qcOpenStudyDisabled);
        setRouteToNodeEnabled(response.data.data?.routeToNodeEnabled);
        setAiRouteToNodeEnabled(response.data.data?.aiRouteToNodeEnabled);
        setEnableReportAndHeaderTemplateConfigurations(response.data.data?.enableReportAndHeaderTemplateConfigurations);
        return true;
      }
    } catch (error) {
      if (error?.response?.status === 403) {
        localStorage.removeItem("hasSession");
      } else {
        console.error("loadByUsername failed unexpectedly", error);
      }
      return false;
    }
  };

  const authenticate2FAOTP = async (username, otp) => {
    try {
      const response = await axios.post(API_BASE_URL + APIs.AUTHENTICA2FATEOTP, {
        data: {
          twoFaAuth: {
            username,
            otp,
          },
        },
      });
      console.log(response);

      setToken(response.data.data.accessToken);
        setUserId(response.data.data.id);
        setUsername(response.data.data.username);
        setEmail(response.data.data.email);
        setRoles(response.data.data.roles);
        setFirmId(response.data.data.firmId);
        setIsActiveData(getEnv("REACT_APP_PARTITION_MODE") == "false" ? true : response.data.data.activeData);
        setEnableLlmReport(response.data.data.enableLlmReport);
        localStorage.setItem("enableLlmReport", response.data.data.enableLlmReport ? "true" : "false");
        setEnableReportAndHeaderTemplateConfigurations(response.data.data.enableReportAndHeaderTemplateConfigurations);
        if(response.data.data?.firmName != undefined && response.data?.data?.firmName != null){
          setFirmName(response.data.data.firmName);
        }
        setQcReviewer(response.data.data.qcReviewer);
        setQcOutsourceLogin(response.data.data.qcOutsourceLogin);
        setName(
          response.data.data.name == undefined
            ? username
            : response.data.data.name
        );
        setShowConfirmation(response.data.data.showConfirmation);
        setLastResetPasswordDate(response.data.data.lastResetPasswordDate);
        if(response?.data?.data?.userSettings?.length > 6 && response?.data?.data?.userSettings != ""){
          const parsedSettings = JSON.parse(response.data.data.userSettings);
          setUserSettings(parsedSettings);
          if (parsedSettings?.theme) {
            localStorage.setItem("theme", parsedSettings.theme);
          }
        }
        if (
          response.data.data.editorName != undefined &&
          response.data.data.editorName != null
        ) {
          setEditorName(response.data.data.editorName);
        } else {
          setEditorName("ckeditor");
        }

        setAuthenticated(true);
        localStorage.setItem("hasSession", "1");
        // localStorage.setItem("refreshToken", response.data.data.refreshToken);
        // localStorage.setItem("username", response.data.data.username);
        localStorage.setItem("forceReset", response.data.data.forceReset);
        localStorage.setItem(
          "redirectOnLogin",
          response.data.data.redirectOnLogin
        );

      return response;
    } catch (error) {
      if (error.response.status === 403) {
        localStorage.removeItem("hasSession");
        window.location.assign(APIs.REDIRECTLOGOUT);
      }
      else return error.response;
    }
  };

  
  

  const authenticate = async () => {
    return await signin(encryptData("dtfirmadmin"), encryptData("Admin@123"));
  };

  const getConsistentDateFormat = (date) => {
    if (Moment(date).isValid()) {
      return Moment(date).format("DD-MMM-YY hh:mm A");
    } else {
      return "No Date";
    }
  };

  const checkForUserAccess = () => {
    if(getEnv("REACT_APP_HYBRID_MODE") == "true"){
        return;
    }
  try{
    if (window.location.pathname.startsWith(AuthRoutes.USER_DATA_DUMP.replace("/*", ""))) {
      return;
    }
    const nonAuthRoutes = Object.values(NonAuthRoutes);
    if (nonAuthRoutes.includes(window.location.pathname)) {
      return;
    }
    if (roles[0] !== undefined) {
      const allowedRoutes = roleAccess[roles[0]];
      if(commonAllowedRolesAccess.includes(window.location.pathname) 
        || allowedRoutes == undefined 
      || roles[0] === USERTYPES.ADMIN){
        return;
      }
      for (const route of allowedRoutes) {
        const regex = new RegExp('^' + route.replace(/:[^/]+/g, '[^/]+') + '$');
        //console.log("---Testing for ----",regex.test(window.location.pathname));
        if (regex.test(window.location.pathname)) {
          return;
        }
      }
      if (window.location.pathname !== AuthRoutes.NOT_ALLOWED) {
        window.location.assign(AuthRoutes.NOT_ALLOWED);
      }
    }
  }catch(e){
    console.log("---Exception---",e);
    return;
  }
    
  };

  useEffect(() => {
      checkForUserAccess()
  }, [roles[0],window.location.pathname]);

  useEffect(() => {
    if (lastResetPasswordDate !== null) {
      const LRPDate = new Date(lastResetPasswordDate);
      const TMPDate = new Date();
      TMPDate.setMonth(TMPDate.getMonth() - 3);
      LRPDate.setHours(0, 0, 0, 0);
      TMPDate.setHours(0, 0, 0, 0);
      const daysDifference =
        Math.abs(
          (TMPDate.getTime() - LRPDate.getTime()) / (1000 * 60 * 60 * 24)
        ) + 1;
      const localStorageField = localStorage.getItem("showPasswordExpiry");
      if (
        daysDifference <= 15 &&
        (localStorageField == null || localStorageField != "false")
      ) {
        setDaysRemainingForExpiry(daysDifference);
        setShowPasswordExpiryMessage(true);
        localStorage.setItem("showPasswordExpiry", true);
      }
    }
  }, [lastResetPasswordDate]);

  const handleHidePasswordExpiryMessage = () => {
    setShowPasswordExpiryMessage(false);
    localStorage.setItem("showPasswordExpiry", false);
  };

  // Fetch tenant default country once on mount.
  // Public endpoint (under /rebranding/**), works pre-login — mobile input fields
  // on login / forgot-password screens get the right country too.
  useEffect(() => {
    axios.get(API_BASE_URL + "rebranding/tenant-country", { withCredentials: false })
      .then((res) => {
        const country = res?.data?.defaultCountry;
        if (country) setDefaultCountry(country);
      })
      .catch((err) => {
        console.debug("Could not fetch tenant default country, falling back to 'in'", err);
      });
  }, []);


  useEffect(() => {
    const reloadPage = localStorage.getItem('reloadPageDataSwitch');
    if (reloadPage) {
      localStorage.removeItem('reloadPageDataSwitch');
      window.location.reload();
    }
  }, [isActiveData]);

  // Proactively refresh the JWT cookie on a timer so it never expires
  // mid-session. Cornerstone's wadors/wadouri XHRs bypass axiosInterceptor,
  // so the interceptor's reactive 403→refresh path doesn't cover image
  // loads — a burst of frame requests hitting an expired cookie would all
  // fail with no recovery. Defaults to every 5 minutes; tune via
  // REACT_APP_JWT_REFRESH_INTERVAL_MS to stay safely under the backend's
  // jwt.expiration.time.min.
  useEffect(() => {
    if (!authenticated) return;
    const configured = parseInt(getEnv("REACT_APP_JWT_REFRESH_INTERVAL_MS"), 10);
    const intervalMs = Number.isFinite(configured) && configured > 0
      ? configured
      : 5 * 60 * 1000;
    const id = setInterval(() => {
      refreshJwtCookie().catch((err) => {
        console.warn("[jwt-refresh] periodic refresh failed", err);
      });
    }, intervalMs);
    return () => clearInterval(id);
  }, [authenticated]);

  return (
    <UserContext.Provider
      value={{
        signin,
        signin2,
        loadByUsername,
        userDetail,
        setUserDetail,
        token,
        authenticate,
        authenticated,
        userId,
        email,
        username,
        roles,
        showSuccessToast,
        setSuccessToast,
        firmId,
        firmName,
        name,
        qcReviewer,
        qcOutsourceLogin,
        showConfirmation,
        editorName,
        getConsistentDateFormat,
        lastResetPasswordDate,
        showPasswordExpiryMessage,
        daysRemainingForExpiry,
        handleHidePasswordExpiryMessage,
        userSettings,
        setUserSettings,
        checkForUserAccess,
        isActiveData,
        setIsActiveData,
        radiologistType,
        unautherizedAccessObj,
        contextSwitchUser,
        contextSwitchStudyviewer,
        enableLlmReport,
        authenticate2FAOTP,
        twoFAGlobalEnable,
        customerSupportNumber,
        privilegedFirmDoctor,
        peerReviewAdmin,
        peerReviewEvaluator,
        resetPasswordAllowed,
        forcedLogoutAllowed,
        disableSubmitforResident,
        typistAllowSubmit,
        multipleActiveSessions, 
        setMultipleActiveSessions,
        blitzSessionEnabled,
        qcSelfLockDisabled,
        qcOpenStudyDisabled,
        routeToNodeEnabled,
        aiRouteToNodeEnabled,
        exportCsvAllowed,
        enableStudyUpload, 
        userTimeZone,
        setUserTimeZone,
        enableReportAndHeaderTemplateConfigurations,
        priviledgedFirmTechnician,
        showViewerTechnician,
        defaultCountry
      }}
    >
      {props.children}
    </UserContext.Provider>
  );
};

export default UserState;
